import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetCascadeProcessActionRequest = App.Http.Requests.Cascade.GetCascadeProcessActionRequest;
import GetCascadeProcessExternalFinalPageSettingRequest = App.Http.Requests.Cascade.GetCascadeProcessExternalFinalPageSettingRequest;
import GetCascadeProcessResponse = App.Http.Responses.Cascade.GetCascadeProcessResponse;
import GetCascadeProcessExternalFinalPageSettingResponse = App.Http.Responses.Cascade.GetCascadeProcessExternalFinalPageSettingResponse;
import GetConversionApiExternalFinalPageResponse = App.Http.Responses.Conversion.GetConversionApiExternalFinalPageResponse;

type CascadeProcessActionRequest = GetCascadeProcessActionRequest & {
    code?: string;
};

class CascadeProcessApi extends TenantBaseApi {
    async show(
        processId: string
    ): Promise<{ data: GetCascadeProcessResponse | GetConversionApiExternalFinalPageResponse; status: number }> {
        return await this.getWithStatus<GetCascadeProcessResponse | GetConversionApiExternalFinalPageResponse, never>(
            `/processes/${processId}`
        );
    }

    async showExternalFinalPageSetting(
        processId: string,
        request: GetCascadeProcessExternalFinalPageSettingRequest = {}
    ): Promise<GetCascadeProcessExternalFinalPageSettingResponse> {
        return await this.get<
            GetCascadeProcessExternalFinalPageSettingResponse,
            GetCascadeProcessExternalFinalPageSettingRequest
        >(`/processes/${processId}/external-final-page-setting`, { params: request });
    }

    async update(
        cascadeProcessId: string,
        action: string,
        cascadeItemId: string,
        request: CascadeProcessActionRequest
    ): Promise<unknown> {
        return await this.get<unknown, CascadeProcessActionRequest>(
            `/processes/${cascadeProcessId}/${action}/${cascadeItemId}`,
            { params: request }
        );
    }
}

export const cascadeProcessApi = new CascadeProcessApi();
